import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import { usePostProjectUpdateInfoMutation } from '../../../../app/api'
import { useTranslation } from 'react-i18next'
import { IUpdateInfoForm } from '../../../projects/model/types/UpdateInfoForm.interface'
import clsx from 'clsx'
import styles from './ProjectEditName.module.scss'

export const ProjectEditName = ({ id, name }: { id?: string; name: string }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [updateInfo] = usePostProjectUpdateInfoMutation()

  const {
    control,
    handleSubmit,
    register,
    formState: { errors, isValid },
  } = useForm<IUpdateInfoForm>({
    mode: 'onChange',
    defaultValues: {
      name,
    },
  })

  const submit = (values: IUpdateInfoForm) => {
    updateInfo({ body: { id: Number(id), name: values.name } }).then(() => dispatch(hideModal()))
  }

  return (
    <form className={clsx(styles.form)} onSubmit={handleSubmit(submit)}>
      <h3 className={clsx(styles.header)}>{t('pages.project.editName')}</h3>
      <div className={clsx(styles.formFields)}>
        <Controller
          render={({ field }) => (
            <BpInput
              {...field}
              required
              error={errors.name?.message}
              label={t('fields.projectName')}
              placeholder={t('pages.project.placeholders.projectName')}
              {...register('name', {
                required: t('fields.validate.required'),
                maxLength: {
                  value: 100,
                  message: t('pages.project.validate.projectName'),
                },
              })}
            />
          )}
          control={control}
          name='name'
        />
      </div>
      <div className={clsx(styles.footer)}>
        <BpButton className={clsx(styles.button)} disabled={!isValid} type='submit'>
          {t('buttons.save')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </form>
  )
}
